// 添付ファイルロード中表示
<template>
  <div
    :class="{ indicator: true, fullscreen: fullscreen }"
    :style="`background: ${backgroundColor};`"
  >
    <div class="indicator-loading-panel">
      <div class="indicator-contents">
        <div class="indicator-spinner">
          <div class="rect1"></div>
          <div class="rect2"></div>
          <div class="rect3"></div>
          <div class="rect4"></div>
          <div class="rect5"></div>
        </div>
        <div class="indicator-loading-message">{{ msg }}</div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.fullscreen {
  position: fixed;
  top: 50px;
  left: 0;
  z-index: 1000; // FABが999なのでそれより上
}
.indicator {
  display: flex;
  cursor: not-allowed;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;

  .indicator-loading-panel {
    display: flex;
    justify-content: center;
    min-height: 160px;
    max-height: 100%;
    overflow: auto;
    width: 100%;

    .indicator-contents {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;

      .indicator-spinner {
        text-align: center;
        margin-bottom: 28px;
        height: 28px;
        width: 80px;

        > div {
          background-color: #00b7c6;
          height: 100%;
          width: 6px;
          display: inline-block;
          margin: 2px;

          -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;
          animation: sk-stretchdelay 1.2s infinite ease-in-out;
        }
        .rect2 {
          -webkit-animation-delay: -1.1s;
          animation-delay: -1.1s;
        }
        .rect3 {
          -webkit-animation-delay: -1s;
          animation-delay: -1s;
        }
        .rect4 {
          -webkit-animation-delay: -0.9s;
          animation-delay: -0.9s;
        }
        .rect5 {
          -webkit-animation-delay: -0.8s;
          animation-delay: -0.8s;
        }
      }
    }
  }
}
@-webkit-keyframes sk-stretchdelay {
  0%,
  40%,
  100% {
    -webkit-transform: scaleY(0.4);
  }
  20% {
    -webkit-transform: scaleY(1);
  }
}
@keyframes sk-stretchdelay {
  0%,
  40%,
  100% {
    transform: scaleY(0.4);
    -webkit-transform: scaleY(0.4);
  }
  20% {
    transform: scaleY(1);
    -webkit-transform: scaleY(1);
  }
}

.indicator-loading-message {
  font-size: 18px;
  font-weight: bold;
  position: relative;
  text-align: center;
  padding: 0 10px;
  word-break: normal;
}
</style>

<script lang="ts">
import { computed, defineComponent } from "vue";

export default defineComponent({
  name: "loading",
  props: {
    msg: { type: String, default: "Now Loading..." },
    fullscreen: { type: Boolean, default: true },
    background: { type: String, default: "transparent" },
  },
  setup(props) {
    const backgroundColor = computed((): string => props.background || "transparent");
    return { backgroundColor };
  },
});
</script>
